module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Pixels-a9b6709286a2341b9b70e710bcaf116ee1205759c37773a69874c6ed37de5a13.svg";